import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import ValidadoLogo from '../components/ValidadoLogo';

const DashboardPage: React.FC = () => {
  const { user } = useAuth();

  return (
    <Container>
      <Box display="flex" alignItems="center" mb={3}>
        <ValidadoLogo width={120} height={48} />
        <Typography variant="h4" sx={{ ml: 2 }}>
          Welcome, {user?.firstName}!
        </Typography>
      </Box>
      <Typography variant="h6">Dashboard functionality coming soon...</Typography>
    </Container>
  );
};

export default DashboardPage;